import { removeMarkdownFromText } from '../../../../../../../utils/markdownUtils';

const shouldReplaceSummary = (summary) =>
  summary && typeof summary === 'string';

export const getShortSummary = (summaryWithMarkdown) => {
  if (shouldReplaceSummary(summaryWithMarkdown)) {
    const summary = removeMarkdownFromText(summaryWithMarkdown);
    const indexOfLastSpace = summary.slice(0, 160).lastIndexOf(' ');
    return summary.length > 160
      ? `${summary.slice(0, indexOfLastSpace)} ...`
      : summary;
  }
  return summaryWithMarkdown;
};
